import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard to protect routes that require specific permissions.
 * CPNotes: Checks if user has required permissions; sends denied users to access-denied
 *
 * Usage: canActivate: [roleGuard(Permissions.users.create, Permissions.users.update)]
 */
export const roleGuard = (...requiredPermissions: string[]): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (requiredPermissions.length === 0) {
      return true;
    }

    const hasPermission = authService.hasAnyPermission(...requiredPermissions);

    if (!hasPermission) {
      router.navigate(['/access-denied']);
      return false;
    }

    return true;
  };
};
